<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

export interface RadiusOption {
  km: number
  to?: RouteLocationRaw
}

const props = defineProps<{
  radiusOptions?: RadiusOption[]
  activeRadiusKm?: number
}>()

const emit = defineEmits<{
  'update:activeRadiusKm': [km: number | undefined]
}>()

const { activeFilter, setFilter } = useClinicFilter()

function onRadiusClick(option: RadiusOption) {
  if (option.to) return
  const newKm = props.activeRadiusKm === option.km ? undefined : option.km
  emit('update:activeRadiusKm', newKm)
}
</script>

<template>
  <div class="space-y-2">
  <div class="bg-muted rounded-xl p-3 flex flex-wrap items-center gap-2">
    <UButton
      color="neutral"
      :variant="activeFilter === 'all' ? 'solid' : 'ghost'"
      size="sm"
      @click="setFilter('all')"
    >
      Vše
    </UButton>
    <UButton
      :color="activeFilter === 'open' ? 'primary' : 'neutral'"
      :variant="activeFilter === 'open' ? 'solid' : 'ghost'"
      size="sm"
      icon="i-lucide-clock"
      @click="setFilter('open')"
    >
      Otevřeno
    </UButton>
    <UButton
      :color="activeFilter === 'emergency' ? 'error' : 'neutral'"
      :variant="activeFilter === 'emergency' ? 'solid' : 'ghost'"
      size="sm"
      icon="i-lucide-siren"
      @click="setFilter('emergency')"
    >
      Pohotovost
    </UButton>
    <UButton
      :color="activeFilter === 'nonstop' ? 'info' : 'neutral'"
      :variant="activeFilter === 'nonstop' ? 'solid' : 'ghost'"
      size="sm"
      icon="i-lucide-clock"
      @click="setFilter('nonstop')"
    >
      Nonstop
    </UButton>

    <template v-if="radiusOptions?.length">
      <div class="hidden sm:block h-5 w-px bg-gray-300 mx-1" />
      <span class="hidden sm:inline text-xs text-dimmed">Širší okolí:</span>
      <UButton
        v-for="option in radiusOptions"
        :key="option.km"
        :color="activeRadiusKm === option.km ? 'primary' : 'neutral'"
        :variant="activeRadiusKm === option.km ? 'solid' : 'ghost'"
        size="sm"
        :to="option.to"
        @click="onRadiusClick(option)"
      >
        +{{ option.km }} km
      </UButton>
    </template>
  </div>
  <p class="text-sm text-dimmed px-1">
    Ne všechny kliniky nabízejí pohotovost. Kliniky s pohotovostí jsou označeny štítkem.
  </p>
</div></template>
